import React from "react";
import _ from "lodash";
import { Routes, Route } from "react-router-dom";

import { lazyRetry } from "src/utils/lazyRetry";

import Register from "src/pages/hazard/Register";
import Detail from "src/pages/hazard/Detail";
import HazardEdit from "src/pages/hazard/Edit";
import OpenBoard from "src/pages/hazard/OpenBoard";
import VerifyFix from "src/pages/hazard/VerifyFix";
import Triage from "src/pages/hazard/Triage";

/* ⚠ ХЯНАЛТЫН САМБАР нь LAZY (2026-10-29). `pages/hazard/Dashboard` нь
     `components/charts` → `@ant-design/plots` → G2Plot-ыг татдаг. Статик
     байсан тул график сан (@antv/g2 794 KB + g2plot 556 KB + component
     221 KB + g-base 115 KB = 1 686 KB эх код) `main.js`-д орж, ажилтан
     аюул БҮРТГЭХЭД ч татагддаг байв.
   ⚠ Самбар нь удирдлага/ХАБЭА-д зориулсан — ажилтны бүртгэх зам БИШ.
     Бүртгэх, дэлгэрэнгүй, баталгаажуулах нь СТАТИК хэвээр.           */
const Dashboard = lazyRetry(() =>
  import(/* webpackChunkName: "hse" */ "src/pages/hazard/Dashboard"),
);

/**
 * HazardRoute — FR-04 Аюулын мэдээлэл (шинэ модуль, Stitch дизайн).
 *   /hazard/dashboard  — хяналтын самбар
 *   /hazard/register   — аюул бүртгэх форм
 *   /hazard/board      — нээлттэй аюул: ажилтан ӨӨРӨӨ шийднэ
 *   /hazard/verify     — удирдлагын баталгаажуулалт + үзүүлэлт
 *   /hazard/triage     — ангилах дараалал: эзэн, хугацаа өгөх (ХАБ хэлтэс)
 *   /hazard/:id        — дэлгэрэнгүй + шийдвэрлэлт
 *   /hazard/:id/edit   — ЗАСАХ: зөвхөн бүртгэсэн ажилтан, NEW
 *                        төлөвт, 2 минутын цонхонд (сервер шалгана)
 *
 * ⚠ `/hazard/:id` нь ХАМГИЙН СҮҮЛД бүртгэгдэнэ — эс бөгөөс `board`,
 *   `verify` гэсэн текстийг id гэж уншиж, дэлгэрэнгүй хуудас нээгдэнэ.
 */
const HazardRoute = () => {
  const data = [
    { path: "/hazard/dashboard", component: <Dashboard /> },
    { path: "/hazard/register", component: <Register /> },
    { path: "/hazard/board", component: <OpenBoard /> },
    { path: "/hazard/verify", component: <VerifyFix /> },
    // ⚠ `:id`-ААС ӨМНӨ. «triage» гэсэн текстийг id гэж уншвал
    //   дэлгэрэнгүй хуудас нээгдэж, ангилах дараалал хүрэхгүй болно.
    { path: "/hazard/triage", component: <Triage /> },
    // ⚠ `:id`-ААС ӨМНӨ: react-router нь дээрээсээ тааруулдаг тул
    //   дараа тавивал «/hazard/2814/edit» нь тааралдахгүй болж
    //   ХООСОН ЦАГААН дэлгэц гарна (2026-11-01-ны гомдол).
    { path: "/hazard/:id/edit", component: <HazardEdit /> },
    { path: "/hazard/:id", component: <Detail /> },
  ];
  return (
    <Routes>
      {_.map(data, (el) => (
        <Route key={el.path} exact path={el.path} element={el.component} />
      ))}
    </Routes>
  );
};

export default React.memo(HazardRoute);
